module.exports = __webpack_public_path__ + "img/test-mkey-qrcode.9cee2960.png";